import gql from 'graphql-tag';

export class LogAuditoriaQuery {
  public static DATOS_ANALITICA_TYPE_QUERY = gql`
    query DATOS_ANALITICA_TYPE_QUERY(
      $jsonString: String!
    ){
      getDatosAnalitica(jsonString: $jsonString) {
        status
        mensaje
        errorMessage
        codigoRespuesta
      }
    }`
}
